import ApiService from '../api.services';

const PriceTableService = {
    list: async function () {
        try {
            const response = await ApiService.get('/api/pricetable');
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    get: async function (id) {
        try {
            const response = await ApiService.get(`/api/pricetable/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    findByPackageService: async function (packagetable, service) {
        try {
            const response = await ApiService.get(`/api/pricetable/${packagetable}/${service}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    add: async function (form, items) {
        const data = {
            pricetable: form
        }
        data.pricetable.items = items;
        try {
            const response = await ApiService.post('/api/pricetable', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    import: async function (form, items) {
        const data = {
            pricetable: form
        }
        data.pricetable.items = items;
        try {
            const response = await ApiService.post('/api/pricetable/import', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    update: async function (packagetable, servicegroup, form, items) {
        const data = {
            pricetable: form
        }
        data.pricetable.items = items;
        try {
            const response = await ApiService.put(`/api/pricetable/${packagetable}/${servicegroup}`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    delete: async function (packagetable, servicegroup) {
        try {
            const response = await ApiService.delete(`/api/pricetable/${packagetable}/${servicegroup}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default PriceTableService;

export { PriceTableService };

